<template>
  <extensions-list
    v-if="selectedUser.id"
    :tier="tierType"
    :id="selectedUser.id"
  />
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import ExtensionsList from "@/views/Common/AttachmentFilters/Extension.vue";

import { TIER } from "@/constants";

export default {
  name: "Extensions",
  components: {
    ExtensionsList,
  },
  data() {
    return {
      tierType: TIER.users,
    };
  },
  computed: {
    ...mapGetters("authentication", ["selectedUser"]),
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
  },
  created() {
    this.setPageTitle(this.$t("Attachments"));
    this.setPageSubtitle([]);
  },
};
</script>
